import { Logger } from '../logger';
import { Config } from '@/environment';
import seon, { SDKOptions } from '@seontechnologies/seon-javascript-sdk';

export interface SeonService {
  loadLibrary(): void;
  getSession(): Promise<string | undefined>;
}

export class AppSeonService implements SeonService {
  private _isSeonLoaded = false;
  private _seonConfig: SDKOptions;

  constructor(
    private config: Config,
    private logger: Logger,
  ) {
    this._seonConfig = {
      dnsResolverDomain: this.config.seon.jsCdnHost,
      silentMode: !this.config.isLocal
    }
  }

  loadLibrary(): void {
    if (!this._isSeonLoaded) {
      try {
        seon.init();
        this._isSeonLoaded = true;
      } catch (err) {
        this.logger.error(`Unable to load SEON API: seonAgent.js`, err as object);
      }
    }
  }

  getSession(): Promise<string | undefined> {
    return seon.getSession(this._seonConfig)
      .catch((err) => {
        this.logger.error(`Unable to generate SEON session: ${err}`);
        return undefined;
      })
  }
}
